import React from 'react'

import { Typography } from '@material-ui/core'

import { ZariContext } from '_zari/context'

import { Portlet, Button, Col, Row, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TipoDocumentoConstant from 'constants/tiposDeDocumentoSunat'
import EstadosTransferenciasConstant from 'constants/estadosTransferencias'

import * as TransferenciaCrud from 'services/transferencia.service'

const portletBreadcrumbs = [
  {
    name: 'Transferencias por Salida',
    path: `/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA}`
  },
  {
    name: 'Detalles'
  }
]

const MainCard = ({ queryParams, history, transferenciaInfo }) => {
  const __zariContext = React.useContext(ZariContext)
  const eliminarTransferencia = () => {
    TransferenciaCrud.eliminarTransferencia(transferenciaInfo._id)
      .then(() => {
        __zariContext.snack('success', 'La transferencia se ha eliminado.')
        history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA}${queryParams}`)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Transferencias por Salida' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Typography color='textSecondary'>Estado</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.estadoEnvio
                  ? EstadosTransferenciasConstant.__dictionary[transferenciaInfo.estadoEnvio].nombre
                  : '--'}
              </Typography>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      <Portlet>
        <Portlet.Body>
          <Row>
            <Col md={2}>
              <Typography color='textSecondary'>Establecimiento Origen</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.sedeOrigen}
              </Typography>
            </Col>
            <Col md={2}>
              <Typography color='textSecondary'>Usuario</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.usuario}
              </Typography>
            </Col>
            <Col md={2}>
              <Typography color='textSecondary'>Tipo de Doc. Emisión</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.tipoDocumento
                  ? TipoDocumentoConstant.__dictionary[transferenciaInfo.tipoDocumento].nombre
                  : '--'}
              </Typography>
            </Col>
            <Col md={2}>
              <Typography color='textSecondary'>Fec. Emision</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.fechaEmision}
              </Typography>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md={2}>
              <Typography color='textSecondary'>Establecimiento Destino</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.sedeDestino}
              </Typography>
            </Col>
            <Col md={2} />
            <Col md={2}>
              <Typography color='textSecondary'>Num. de Doc. Emisión</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.serieDocumento} - {transferenciaInfo.numeroDocumento}
              </Typography>
            </Col>
            <Col md={2}>
              <Typography color='textSecondary'>Fec. Recepcion</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.fechaRecepcion}
              </Typography>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      <Portlet>
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Typography color='textSecondary'>Comentario</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.comentario || 'No hay comentarios disponibles.'}
              </Typography>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      <Portlet>
        <Portlet.Body>
          <Table.ClientSide
            headRows={[{ label: 'PRODUCTO' }, { label: 'PRESENTACION' }, { label: 'CANTIDAD' }]}
            filas={transferenciaInfo.detalles || []}
            rowTemplate={(row, k) => (
              <Table.Row hover key={k}>
                <Table.Cell>{row.producto || '--'}</Table.Cell>
                <Table.Cell>{row.presentacion || '--'}</Table.Cell>
                <Table.Cell>{row.cantidad || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {transferenciaInfo.estadoEnvio === EstadosTransferenciasConstant.ENVIO_ENVIADO && (
        <Portlet>
          <Portlet.Body>
            <Col md={12} className='text-right'>
              <Button color='danger' type='submit' onClick={eliminarTransferencia}>
                Eliminar
              </Button>
            </Col>
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default MainCard
